import { call, put } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { RunExtractTasksAction } from '../../extract/services/RunExtractTasksAction';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { RunExtractRefreshAction } from '../actions/RunExtractRefreshAction';

export function* handleRunExtractRefreshAction(action: RunExtractRefreshAction) {
  try {
    yield call(executeRunExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeRunExtractRefresh(items: IExtractTaskInfo[]) {
  return RunExtractTasksAction.execute(Set.fromIdItemArray(items));
}
